import {
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react';
import { useLocation, useHistory, useRouteMatch } from 'react-router-dom';
import BaseUrlContext from '../contexts/BaseUrlContext';
import useIsMounted from './useIsMounted';

function useDetailHandler(baseDetailSlug) {
    const location = useLocation();
    const history = useHistory();
    const baseUrl = useContext(BaseUrlContext);
    const [isDetailVisible, setDetailVisibility] = useState(false);
    const [detailSlug] = useState(String(baseDetailSlug).toLowerCase());
    const isMounted = useIsMounted();

    const match = useRouteMatch(`${baseUrl}/${detailSlug}`);
    useEffect(() => {
        setDetailVisibility(!!match);
    }, [match, setDetailVisibility]);

    const onDetailDelete = useCallback(() => {
        if (isMounted()) {
            history.push(`${baseUrl}${location.search}`);
        }
    }, [baseUrl, history, isMounted, location.search]);

    const toggleDetail = useCallback(() => {
        if (isMounted()) {
            if (isDetailVisible) {
                onDetailDelete();
            } else {
                history.push(`${baseUrl}/${detailSlug}${location.search}`);
            }
            setDetailVisibility(!isDetailVisible);
        }
    }, [baseUrl, detailSlug, history, isDetailVisible, isMounted, location.search, onDetailDelete]);

    return { isDetailVisible, toggleDetail, onDetailDelete };
}

export default useDetailHandler;
